import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@common-ui/ui';
import { useAppDispatch } from '../../../store/configureStore';
import { clearSelectedImages, clearTemporaryImageIds } from '../../../store/slices/imagesSlice';

export default function Clear() {
  const dispatch = useAppDispatch();
  const { selectedImageIds } = useSelector((state) => state.images);
  const clearSelection = () => {
    dispatch(clearSelectedImages());
    dispatch(clearTemporaryImageIds());
  };
  return (
    selectedImageIds.length > 0 && (
      <Typography sx={button} onClick={clearSelection}>
        Clear Selection
      </Typography>
    )
  );
}
const button = {
  '&:hover': { cursor: 'pointer' },
  color: '#2196F3',
  zIndex: 99,
  position: 'relative',
};
